import React, { useState, createContext, useContext, useEffect, useCallback } from 'react';

interface IPlaylistContext {
    setParams: React.Dispatch<React.SetStateAction<IParams | null>>
    handleOpenCloseDropdown: (moduleIndex: number) => void
    dropdownActive: number | null
    sideBarActive: boolean
    setSideBarActive: React.Dispatch<React.SetStateAction<boolean>>
}

interface IParams {
    moduleId: string,
    lessonId: string,
}

interface IProps {
    children: React.ReactNode
}

export const PlaylistContext = createContext<IPlaylistContext | null>(null);

export const PlaylistProvider = ({ children }: IProps): JSX.Element => {
    const [params, setParams] = useState<IParams | null>(null);
    const [dropdownActive, setDropdownActive] = useState<number | null>(null);
    const [sideBarActive, setSideBarActive] = useState(false);

    useEffect(() => { if (params) setDropdownActive(parseInt(params.moduleId, 10)); }, [params]);

    const handleOpenCloseDropdown = useCallback((moduleIndex: number) => {
        if (dropdownActive === moduleIndex) return setDropdownActive(null);
        setDropdownActive(moduleIndex);
    }, [dropdownActive]);

    return (
        <PlaylistContext.Provider value={{ setParams, handleOpenCloseDropdown, dropdownActive, sideBarActive, setSideBarActive }}>
            {children}
        </PlaylistContext.Provider>
    );

};

export const usePlaylist = () => {
    const context = useContext(PlaylistContext);
    if (!context) throw new Error('usePlaylist must be used within an PlaylistProvider');
    return context;
};
